import type React from 'react';
import styled from 'styled-components';

export type ObjectColor = `#${string}` | 'Vertex';

export const ColorMarker: React.FC<{
  color: ObjectColor;
}> = (props) => {
  return <Container {...props}></Container>;
};

const Container = styled.div<{ color: ObjectColor }>`
  width: 0.5em;
  height: 1.4em;
  background: ${({ color }): string =>
    color === 'Vertex' ? 'linear-gradient(to top, red, orange, yellow, green)' : color};
  box-shadow:
    0px 0px 2px rgba(0, 0, 0, 1),
    0px 0px 1px rgba(0, 0, 0, 1); /* Shadow: horizontal-offset, vertical-offset, blur-radius, color */
`;
